import { BuyerBriefRef } from "../types/BuyerBriefTypes";

/**
 * Where a vendor's buyer brief lives. The server resolves which brief that is
 * (a new one or a legacy supplier record) and the reference's type is the
 * route segment, so the path needs no knowledge of either.
 */
export const buyerBriefRefPath = (ref?: BuyerBriefRef): string | undefined =>
    ref ? `/${ref.type}/${ref.id}` : undefined;
